module.exports = __webpack_public_path__ + "media/images/spc_explained-b2a609dc.png";